import {Component, input, InputSignal} from '@angular/core';
import {DsMessageModule} from '@bmw-ds/components';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-dms-search-message',
  templateUrl: './dms-search-message.component.html',
  styleUrls: ['./dms-search.scss'],
  imports: [DsMessageModule, TranslateModule]
})
export class DmsSearchMessageComponent {

  readonly showErrorIndicator: InputSignal<boolean> = input<boolean>(false);
  readonly showNoResultInfo: InputSignal<boolean> = input<boolean>(false);
  readonly errorMessage: InputSignal<string> = input<string>();
}
